export default "__VITE_ASSET__W_ZXTAvb__";